// src/pages/SellerIntelligence/Promotions/Promotions.js
//
// Promotion Performance Tracker.
//
// Most of this feature is a roll-up BY DESIGN: its PRD says SF2 and SF6 are
// covered by Pricing Strategy Analyzer SF1, and SF3 by SF2. The episode engine
// already measures lift against a counterfactual, and measuring it again here
// would produce a second set of numbers for the same question.
//
// SF1 (the live dashboard of what is running now) reads the Promotions API
// directly, as the PRD requires: a report is never the source of whether a
// promotion is active, because it lags and would show a finished promotion as
// live. It is the one panel here that is not built from landed reports.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

import styles from '../SellerIntelligence.module.css';
import RunningNow from './components/RunningNow';
import PromotionReturns from './components/PromotionReturns';
import DepthAndSpikes from './components/DepthAndSpikes';

const Promotions = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.featureContainer}>
      <div className={styles.header}>
        <button className={styles.backButton}
          onClick={() => navigate('/dashboard/seller-intelligence/pricing')}>
          <FiArrowLeft /> Back
        </button>
        <div className={styles.titleSection}>
          <div className={styles.iconTitle}><h1>Promotion Performance</h1></div>
          <p>Whether your promotions made money, after every cost Seller Central does not count.</p>
        </div>
      </div>

      <div className={styles.content}>
        <RunningNow />
        <PromotionReturns />
        <DepthAndSpikes />
      </div>
    </div>
  );
};

export default Promotions;
